const __attr = require('./attr.js');
const __class = require('./class.js');
const __control = require('./control.js');
const __css = require('./css.js');
const __event = require('./event.js');
const __find = require('./find.js');
const __page = require('./page.js');

let __module = {};
Object.assign(
  __module,
  __attr, 
  __class, 
  __control, 
  __css, 
  __event, 
  __find,
  __page
);

module.exports = __module;
